module.exports = __webpack_public_path__ + "img/Slide1.0b891f68.jpg";